module.exports = __webpack_public_path__ + "img/kanettes-pictos-knett-du-mois.bb5737b8.png";